'use strict'

module.exports = require('./html')



// WEBPACK FOOTER //
// ./node_modules/hastscript/index.js